import { render, staticRenderFns } from "./accordion-item.vue?vue&type=template&id=960d763e&scoped=true"
import script from "./accordion-item.vue?vue&type=script&lang=ts"
export * from "./accordion-item.vue?vue&type=script&lang=ts"
import style0 from "./accordion-item.vue?vue&type=style&index=0&id=960d763e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960d763e",
  null
  
)

export default component.exports